import auth from "./auth";
import client from "./client";
import design from "./design";
import utilities from "./utilities";
import notification from "./notification";

export default {
  auth: auth,
  client: client,
  design: design,
  utilities: utilities,
  notification: notification,
};
